  document.addEventListener('DOMContentLoaded', function () {
    // Query all Swiper containers dynamically
    document.querySelectorAll('[class*="drawermegamenuswiper_"]').forEach((swiperEl) => {
      // Skip if already initialized
      if (swiperEl.dataset.initialized === 'true') return;

      new Swiper(swiperEl, {
        slidesPerView: 2.5,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next-mega',
          prevEl: '.swiper-button-prev-mega',
        },
        breakpoints: {
          768: {
            slidesPerView:2.5
          },
          1024: {
            slidesPerView: 2.5
          }
        }
      });

      swiperEl.dataset.initialized = 'true';
    });
  });



// outer slider

function initDrawerSwiper() {
  document.querySelectorAll('.drawerswiperOuter').forEach((swiperEl) => {
    if (swiperEl.dataset.initialized === 'true') return;

    // Only initialize if swiperEl is visible
    if (swiperEl.offsetParent === null) return; // not visible

    const swiper = new Swiper(swiperEl, {
      slidesPerView:'auto',
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
    });

    swiperEl.dataset.initialized = 'true';
  });
}

document.addEventListener('DOMContentLoaded', initDrawerSwiper);
document.addEventListener('shopify:section:load', initDrawerSwiper);
document.addEventListener('shopify:section:select', initDrawerSwiper);











